<template>
  <div class="multi-route-and-print">
    <template v-if="useRoute && values.length > 0">
      <router-link
        v-for="(value, index) in values"
        :key="index"
        :to="fullPath"
        tag="a"
        style="color:#0000FF;"
        @click.native="jumpMethod(value)"
      >
        {{ value }}<span v-if="index < values.length - 1">,</span>
      </router-link>
    </template>
    <span v-else>{{ data[field] }}</span>
    <i v-if="usePrint" class="el-icon-search" style="margin-left:5px;color:#0000FF;cursor:pointer" @click="printMethod" />
  </div>
</template>

<script>
export default {
  name: 'MultiRouterAndPrint',
  props: {
    // 是否开启路由
    useRoute: {
      type: Boolean,
      default: () => true
    },
    // 是否开启打印
    usePrint: {
      type: Boolean,
      default: () => true
    },
    // 行数据
    data: {
      type: Object,
      default: () => ({})
    },
    // 列key
    field: {
      type: String,
      default: () => ''
    },
    // 跳转回调
    jumpMethod: {
      type: Function,
      default: () => { }
    },
    // 打印回调
    printMethod: {
      type: Function,
      default: () => { }
    },
    // 是否限制显示条数
    limitNumber: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      fullPath: this.$route.fullPath,
      values: []
    }
  },
  created() {
    const str = this.data[this.field]
    if (str && typeof str === 'string') {
      this.values = str.split(',')
      if (this.values && this.values.length > 50) {
        this.values = this.values.splice(0, 50)
      }
    }
  }
}
</script>

<style lang="scss">
.multi-route-and-print {
  .el-link {
    font-size: 12px;

    &.el-link--default {
      color: rgb(0, 82, 204);

      &:hover {
        color: rgb(0, 82, 204)
      }
    }
  }
}
</style>
